import type { CustomIncludedPerilsProps } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import {
  FormulaGuaranteeLines,
  useQuotePerils,
  valuedPerilLabel,
  type FormulaGuaranteeLine,
} from './FormulaGuaranteeLines';

const T_PREFIX = 'tutassurHiscoxResponsabiliteDirigeants';

export function IncludedPerilsDirigeants({ tier }: CustomIncludedPerilsProps) {
  const { t } = useTranslation();
  const perils = useQuotePerils(tier);

  const lines: FormulaGuaranteeLine[] = [
    { key: 'LOI', label: valuedPerilLabel(t, T_PREFIX, perils, 'LOI'), active: true },
  ];

  return <FormulaGuaranteeLines lines={lines} />;
}
